import React from 'react';
import { FadeIn } from './FadeIn';
import { Trophy, CheckCircle2 } from 'lucide-react';
export function SolutionOverview() {
  const benefits = ['Ahorrás tiempo real (y energía mental)', 'Te sentís más seguro/a en cada decisión', 'Resolución rápida de patologías frecuentes', 'Seguimiento con criterio cuando no avanza', 'Comunicación lista para decir (sin improvisar)'];
  return <section className="pt-8 pb-6 px-4 max-w-4xl mx-auto" data-id="element-272">
      <FadeIn className="text-center mb-8" data-id="element-273">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-mint/20 text-mint mb-4" data-id="element-274">
          <Trophy size={32} data-id="element-275" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-mint mb-3" data-id="element-276">
          Sistema práctico para nutricionistas
        </h2>
        <p className="text-xl text-mint/70 font-medium mb-5" data-id="element-277">
          (consulta real, sin vueltas)
        </p>

        <div className="bg-surface p-8 rounded-2xl shadow-md border border-mint/10 mb-6" data-id="element-278">
          <h3 className="font-bold text-2xl text-mint mb-2 bg-[#141414]" data-id="element-279">
            <span className="text-white text-[20px]" data-id="element-280">
              🥑SALUD EN TU PLATO™
            </span>{' '}
            MEGAPACK NUTRI PRO LISTO
          </h3>
          <p className="text-lg text-white/70 mb-4" data-id="element-281">5 TOMOS + BONOS</p>
          <p className="font-medium text-mint bg-mint/10 inline-block px-4 py-2 rounded-lg" data-id="element-282">
            +300 páginas aprox. · Checklists · Protocolos · Guiones ·
            Plantillas. Funciona desde hoy.
          </p>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-283">
        {benefits.map((benefit, idx) => <FadeIn key={idx} delay={idx * 0.1} className="flex items-center gap-3 bg-surface p-4 rounded-xl border border-mint/10" data-id="element-284">
            <CheckCircle2 className="text-mint shrink-0" size={24} data-id="element-285" />
            <span className="font-medium text-white/80" data-id="element-286">{benefit}</span>
          </FadeIn>)}
      </div>
    </section>;
}